import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const login = r => require.ensure([], () => r(require('./page/login.vue')), 'login')//登录
const user = r => require.ensure([], () => r(require('./page/user.vue')), 'user') //用户管理
const website = r => require.ensure([], () => r(require('./page/website.vue')), 'website') //首页


let routeObj = {login,user};

const routes = [];

for (let name in routeObj ) {
    routes.push({path:`/${name}`,name,component:routeObj[name]});
}

routes.push({path:`/`,name:'website',component:website});

const router = new VueRouter({routes});

router.beforeEach((to, from, next) => {
    let toName = to.name;
    let toPath = to.path;
    if (toName == 'login') {//登录界面
        if (localStorage.token) {//已经登录的
            sessionStorage.hasBar = 1;
            let path = '/';
            sessionStorage.toPath = path;
            next({path});
        } else {
            sessionStorage.hasBar = 0;
            next();
        }
    }else{//非登录界面
        if (localStorage.token) {//已登录
            sessionStorage.hasBar = 1;
            if(!toName){//没有定义的路由
                let path = '/';
                sessionStorage.toPath = path;
                return next({path});
            }
            sessionStorage.toPath = toPath;
            next();
        }else {
            sessionStorage.hasBar = 0;
            next({path: '/login'});
        }
    }
})

export default router;